import PersonModel from'./PersonModel';
class ModelForAdd {
    person = [];
    address = [];
    auto = [];
    company = [];
    contact = [];
    documents = [];
    gun = [];
    opm = [];
    opms = [];
    proceeding = [];
    photo = [];
    files = [];
    traitors = [];
    bs = [];
    kan = [];
}

export default ModelForAdd